/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum ApplicationEvent {
  /**
   * This event is fired when the application is started
   */
  APP_START = 'app_start',
  /**
   * This event is fired when the application is ended
   */
  APP_END = 'app_end',
  /**
   * This event is fired when there is an application error
   */
  APP_ERROR = 'app_error',
  /**
   * This event is fired when the application is brought to the foreground
   */
  APP_FOREGROUND = 'app_foreground',
  /**
   * This event is fired when the application is pushed to the background
   */
  APP_BACKGROUND = 'app_background',
  /**
   * This event is used to report application errors.
   */
  ERROR = 'error',
}
